module.exports = __webpack_public_path__ + "static/img/12@3x.fb5ddd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/12@3x.png
// module id = 6K4Z
// module chunks = 0